module.exports = __webpack_public_path__ + "static/c_1-e7b155c04c597a27c57298dce550b446.jpg";